import { createMuiTheme, Theme } from "@material-ui/core";
import deepOrange from "@material-ui/core/colors/deepOrange";
import orange from "@material-ui/core/colors/orange";
import indigo from "@material-ui/core/colors/indigo";
import green from "@material-ui/core/colors/green";
import red from "@material-ui/core/colors/red";
import yellow from "@material-ui/core/colors/yellow";
import lightBlue from "@material-ui/core/colors/lightBlue";
import grey from "@material-ui/core/colors/grey";

declare module "@material-ui/core/styles/createMuiTheme" {
	interface Theme {
		status: {
			reservation: {
				payed: string;
				awaitingPayment: string;
				expiredPayment: string;
				bookedOnline: string;
				manual: string;
			},
			payment: {
				awaitingPayment: string;
				completed: string;
				expired: string;
				pending: string;
			}
		}
	}

	interface ThemeOptions {
		status: {
			reservation: {
				payed: string;
				awaitingPayment: string;
				expiredPayment: string;
				bookedOnline: string;
				manual: string;
			}
			payment: {
				awaitingPayment: string;
				completed: string;
				expired: string;
				pending: string;
			}
		}
	}
}

export const theme: Theme = createMuiTheme({
	palette: {
		primary: deepOrange,
		secondary: indigo,
	},
	typography: {
		fontSize: 16,
	},
	status: {
		reservation: {
			payed: green[700],
			awaitingPayment: yellow[700],
			expiredPayment: grey[800],
			bookedOnline: lightBlue[800],
			manual: deepOrange[500],
		},
		payment: {
			awaitingPayment: yellow[600],
			completed: green[600],
			expired: red[700],
			pending: orange[500],
		}
	}
});
